var _style, _polygon, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 60",
    style: {
      enableBackground: "new 0 0 492 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33BC95;stroke-width:5.6752;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#33BC95;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.6,13 24.1,31.6 24.1,55.7 76.1,55.7 76.1,4.7 25.1,4.7 24.1,31.6 5.6,47.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.4,4.8c11.2,0,18.2,4.9,18.2,12.7c0,5.5-3.3,9.8-8.8,11.2c6.5,1.2,10.6,6.2,10.6,12.9 c0,8.7-7.3,14.1-19.2,14.1H102V4.8H125.4z M113.4,25.3h11.3c4.3,0,7-2.1,7-5.7c0-3.5-2.7-5.5-7-5.5h-11.3V25.3z M113.4,46.3h11.3 c5.5,0,8.7-2.3,8.7-6.2c0-3.7-3.3-6-8.7-6h-11.3V46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.8,30.2c0,14.7-11.8,26-27.3,26c-15.6,0-27.3-11.2-27.3-26c0-14.8,11.8-25.8,27.3-25.8 C193,4.4,204.8,15.5,204.8,30.2z M161.9,30.2c0,8.9,7.2,15.9,15.7,15.9c8.5,0,15.4-7,15.4-15.9c0-8.9-6.9-15.8-15.4-15.8 C169,14.4,161.9,21.3,161.9,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.3,55.7h-13.7l-12-16.9l-11.8,16.9h-13.5l18.3-26l-17-24.9h13.4l10.6,15.6l10.7-15.6h13.6l-16.9,24.4 L258.3,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,4.8c12.9,0,20.4,6.4,20.4,17.7c0,11.9-7.4,18.7-20.4,18.7h-10.1v14.5h-11.5V4.8H286.4z M276.3,31.5h9.5 c6.4,0,10-2.9,10-8.7c0-5.7-3.6-8.5-10-8.5h-9.5V31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.6,55.7V35.6h-23.1v20.1h-11.5V4.8h11.5V26h23.1V4.8h11.5v50.9H348.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.3,55.7V4.8h11.5v50.9H371.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432,9.8l-4.4,9.5c-5.4-3.2-11.8-5.2-15.9-5.2c-3.9,0-6.5,1.4-6.5,4.1c0,9.4,27.1,4.1,27.1,22.5 c0,10-8.7,15.3-19.9,15.3c-8.4,0-16.7-3.2-22.5-8.1l4.6-9.4c5.2,4.7,12.7,7.6,18,7.6c4.7,0,7.6-1.7,7.6-4.9c0-9.6-27.1-4-27.1-22 c0-9.2,7.9-15.1,19.7-15.1C419.8,4.3,426.9,6.4,432,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.9,55.7V35.6h-23.1v20.1h-11.5V4.8h11.5V26h23.1V4.8h11.5v50.9H474.9z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 64.6,
    cy: 22.6,
    r: 3.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f5a823c09f2746d28459d3e935b7e4a.svg";
export { ForwardRef as ReactComponent };